/**
 * Configuration
 */

export default {
    name: 'likely',
    prefix: 'likely__',
};
